export default function (...clzs) {
  // TODO temp, try to do same as properties.
  return clzs.reduce((c1, c2) => {
    const c3 = c2(c1);
    c3.styles = [].concat(c1.styles || []).concat(c3.styles || []);
    c3.formatters = { ...c1.formatters, ...c3.formatters };
    return c3;
  });
}
